import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { onboardingApi } from '@/lib/api/onboarding';

const HEARTBEAT_INTERVAL_MS = 60_000; // 60 seconds

/**
 * Sends session heartbeats to the backend for visit/session tracking.
 * A new session is created server-side if no heartbeat in 3+ hours.
 * Place this in the authenticated app shell.
 */
export function useSessionHeartbeat() {
  const location = useLocation();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    const sendHeartbeat = () => {
      onboardingApi.sendHeartbeat(location.pathname).catch(() => {
        // Silently ignore errors - heartbeat is best-effort
      });
    };

    // Send immediately on page change
    sendHeartbeat();

    // Set up interval
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
    intervalRef.current = setInterval(sendHeartbeat, HEARTBEAT_INTERVAL_MS);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [location.pathname]);
}
